export default "__VITE_ASSET__CMSIO9a1__"